import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-cookies',
  templateUrl: 'cookies.html',
})
export class CookiesPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CookiesPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/cookies/cookies.ts